module.exports = __webpack_public_path__ + "img/Single options.1887e48.png";